import { render, staticRenderFns } from "./MilestoneSwiper.vue?vue&type=template&id=bb16978a&scoped=true&"
import script from "./MilestoneSwiper.vue?vue&type=script&lang=js&"
export * from "./MilestoneSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneSwiper.vue?vue&type=style&index=0&id=bb16978a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb16978a",
  null
  
)

export default component.exports